<div class="preview-wrapper" *ngIf="file && mimeType" (click)="onViewClick($event)">
  <div class="file-container">

    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Hover-buttons overlay -->
    <div class="buttons-overlay">
      <!-- <div class="btn d-flex">
        <span class="primary-c m-auto truncate-text max-width" matTooltip="{{name}}">
          {{ name || '-' }}
        </span>
      </div> -->
      <button type="button" class="btn view-btn" (click)="onViewClick($event)">
        <mat-icon style="font-size: 18px;" [fontSet]="'material-icons'" matListItemIcon>visibility</mat-icon>
      </button>
    </div>

    <!-- Preview content -->
    <pre *ngIf="mimeType.startsWith('text')" class="preview-text" (load)="onMediaLoaded()">{{ textContent }}</pre>
    <img (load)="onMediaLoaded()" *ngIf="mimeType.startsWith('image')" [src]="safeUrl" class="preview-media" alt="..." />
    <audio (loadeddata)="onMediaLoaded()" *ngIf="mimeType.startsWith('audio')" [src]="safeUrl" controls class="preview-media center"></audio>
    <video (loadeddata)="onMediaLoaded()" *ngIf="mimeType.startsWith('video')" [src]="safeUrl" controls class="preview-media"></video>

    <div (load)="onMediaLoaded()" *ngIf="mimeType === 'application/pdf' || mimeType === 'text/html'" class="pdf-container pointer">
      <mat-icon style="margin: auto;">picture_as_pdf</mat-icon>
      <div class="primary-c">click to see in detail</div>
    </div>

    <p *ngIf="!mimeType.startsWith('image') &&
              !mimeType.startsWith('video') &&
              !mimeType.startsWith('audio') &&
              !mimeType.startsWith('text') &&
              mimeType !== 'application/pdf' &&
              mimeType !== 'text/html'">
      Cannot preview this file type: {{ mimeType }}
    </p>
  </div>
</div>

<!-- Fullscreen overlay -->
<div class="fullscreen-overlay" *ngIf="isFullScreen" (click)="closeFullScreen()">
  <div class="fullscreen-content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeFullScreen()">
      <mat-icon [fontSet]="'material-icons'" matListItemIcon>close</mat-icon>
    </button>
    <div class="file-container-full">
      <pre *ngIf="mimeType?.startsWith('text')" class="fullscreen-text">{{ textContent }}</pre>
      <img *ngIf="mimeType?.startsWith('image')" [src]="safeUrl" class="fullscreen-media" />
      <audio *ngIf="mimeType?.startsWith('audio')" [src]="safeUrl" controls class="fullscreen-media"></audio>
      <video *ngIf="mimeType?.startsWith('video')" [src]="safeUrl" controls class="fullscreen-media"></video>
      <iframe *ngIf="mimeType === 'application/pdf' || mimeType === 'text/html'"
              [src]="safeUrl"
              class="fullscreen-media"></iframe>
      <p *ngIf="!mimeType?.startsWith('image') &&
                !mimeType?.startsWith('video') &&
                !mimeType?.startsWith('audio') &&
                !mimeType?.startsWith('text') &&
                mimeType !== 'application/pdf' &&
                mimeType !== 'text/html'">
        Cannot preview this file type: {{ mimeType }}
      </p>
    </div>
  </div>
</div>
